export const BYTES_IN_GB = 1024 * 1024 * 1024; // 1 GB in bytes
export const MEMORY_CHECK_INTERVAL_MS  = 60000 // 1 Min interval
export const MEMORY_USAGE_THRESHOLD_PERCENT = 75; // Memory usage warning threshold in percentage 75%
export const MIN_MEMORY_THRESHOLD_IN_PERCENT = 0.1 //e.i min threshold is 10% of jsHeapSizeLimit
export const THRESHOLDS_STEPS =  0.2 //e.i start with min threshold and take 0.2 GB per steps
